import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.681,12.215l-14.761,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.255,8.908l-3.335,3.21l3.259,3.405",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.65,15.39l0,5.294c0,0.776 -0.602,1.405 -1.344,1.405l-9.642,0c-0.742,0 -1.344,-0.629 -1.344,-1.405l0,-17.367c0,-0.776 0.602,-1.405 1.344,-1.405l9.642,0c0.742,0 1.344,0.629 1.344,1.405l0,5.537",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgLogout;
